import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { EmbedContainer } from "./common-container";
import { loadData } from "../loadData";
import { withLocale } from "../utils/locale";
import { Header, PoweredByScoopIt } from "./common-header";
import classname from "classname";
import { Description, Insight, LinkImage, Meta, Title } from "./common-posts";
import { Paginator } from "./common-pagination";
import { Tags } from "./common-tags";

export const DEFAULT_SECTIONS = ["media", "title", "meta", "content", "insight"];

// basic list
// extra params:
// maxPosts
// locale
// section: default: ["media", "title", "meta", "content", "insight"] putting media > first place = image at the right
// displayHeader: default: true
// displayPaginator: (default: true)
// displayTags: (default: false)
const ListRenderer = ({
    data,
    maxPosts,
    locale,
    displayHeader = true,
    sections = DEFAULT_SECTIONS,
    displayPoweredByScoopIt = true,
    displayPaginator = true,
    displayTags = false,
    tagCloudTitle = null,
    maxTagsCount = null,
}) => {
    dayjs.locale(locale);
    const ref = useRef();
    const [small, setSmall] = useState(true);
    useEffect(() => {
        const computeSmall = () => {
            const elt = ref.current;
            const width = elt.offsetWidth;
            const newSmall = width < 700;
            if (newSmall != small) {
                setSmall(newSmall);
            }
        }
        window.addEventListener("resize", computeSmall);
        computeSmall();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", computeSmall);
    });

    return <EmbedContainer ref={ref}>
        <Header
            data={data}
            displayHeader={displayHeader}
            outsidePoweredBy={small}
            headerImageSizeClasses={
                "scp-w-28 scp-h-28"
            }
            displayPoweredByScoopIt={displayPoweredByScoopIt}
        />
        {displayTags && <Tags tags={data.tags} maxTagsCount={maxTagsCount} tagCloudTitle={tagCloudTitle} />}
        {
            data.posts.map((post, i) => (!maxPosts || maxPosts > i) && <ListPost sections={sections} post={post} key={i} />)
        }
        {displayPaginator && <Paginator />}
        {displayPoweredByScoopIt && data.creator && <PoweredByScoopIt />}
    </EmbedContainer>
}

const ListPost = ({ sections, post, disableEmbeds }) => {
    return <div className="scp-flex scp-gap-4 scp-p-4 scp-rounded-sm scp-shadow-md scp-embed-block scp-embed-post-container">
        {
            sections.indexOf("media") == 0 && <ListPostImage post={post} />
        }
        <div className="scp-flex-1 scp-flex scp-flex-col scp-gap-0.5">
            {sections.map((section, i) => {
                switch (section) {
                    case "title":
                        return <Title href={post.url} key={i}>{post.title}</Title>;
                    case "media":
                        return null;
                    case "meta":
                        return <Meta {...post} key={i} />;
                    case "content":
                        return <Description dangerouslySetInnerHTML={{ __html: post.html_content }} key={i} />;
                    case "insight":
                        return <Insight {...post} key={i} />;
                }
            })
            }
        </div>
        {
            sections.indexOf("media") > 0 && <ListPostImage post={post} />
        }

    </div>
}

const ListPostImage = ({ post }) => post.square_image_url && <div className="scp-flex-shrink-0">
    <LinkImage
        href={post.url}
        target="blank"
        className="scp-w-28 scp-h-28"
        src={post.square_image_url}
    />
</div>

export const List = loadData(withLocale(ListRenderer));